import { getOriginRoot } from "../utils/constants";
import { formalize } from "../utils/strings";

export const CommonImages = {

    // Calendar Logos
    ECAL_LOGO_ROUND: 'v2/media/images/logo-round.svg?v=2',
    ECAL_LOGO_RECT: 'v2/media/svg/logo-round.svg',
    GOOGLE_LOGO: 'v2/media/images/calendar-logo-google.svg',
    ANDROID_LOGO: 'v2/media/images/android-logo.svg',
    APPLE_LOGO: 'v2/media/images/calendar-logo-apple.svg',
    OUTLOOK_LOGO: 'v2/media/images/calendar-logo-outlook-old.svg',
    NEW_OUTLOOK: 'v2/media/images/calendar-logo-outlook-new.svg',
    OFFICE365_LOGO: 'v2/media/images/calendar-logo-office365.svg',
    OTHER_LOGO: 'v2/media/images/calendar-logo-otherICS.svg',

    DEFAULT_SCHEDULE_LOGO: 'v2/media/images/calendar-logo-otherICS.svg',
    LIGHTING: 'v2/media/images/lightning.svg',
    ECAL_FOOTER_LOGO: 'v2/media/images/powered-by-ecal.svg',
    INAPP_GUIDE_ARROW_TOP: 'v2/media/images/Arrow-Top.png',
    INAPP_GUIDE_ARROW_BOTTOM: 'v2/media/images/Arrow-Bottom.png',
    ECAL_INAPP_LOGO: 'v2/media/images/ECAL-In-App-Logo.svg',
    ECAL_BAR_LOGO: 'v2/media/images/ecal-bar-logo.svg',
    ECAL_PUBLISHER_LOGO: 'v2/media/images/ecal-header-logo.svg',
    ECAL_LOADING_LOTTIE: 'v2/media/images/lottiefiles/ecal-loading.lottie',
    DIALOG_TAIL: 'v2/media/images/dialog-tail.png',
    EXCLAMATION_WARNING: 'v2/media/images/exclamation-icon.svg',
    ECAL_CONNECTOR: 'v2/media/images/connector-animation.gif',

    OUTLOOK_NEW_GUIDE: 'https://d27vx6ekipa712.cloudfront.net/assets/in-app-guide/new-outlook-desktop-guide.png',
    OUTLOOK_GUIDE_INFO: 'https://ecal-dynamic-assets.s3.us-east-1.amazonaws.com/assets/in-app-guide/new-outlook-desktop-guide.svg',

    LOADER: 'v2/media/images/loader.gif',
    LOADING_CONNECTOR_LOTTIE: 'v2/media/images/lottiefiles/ecal-connector.lottie',
    GREEN_TICK_ICON: 'v2/media/images/tick-icon.svg',
    WARNING_ICON: 'v2/media/images/warning-icon.svg',

    ALMOST_DONE: {
        IOS_OTHER: 'v2/media/almostdone/ios-other.png',
        IOS_SAFARI: 'v2/media/almostdone/ios-safari.png',
        MAC_CHROME: 'v2/media/almostdone/mac-chrome.png',
        MAC_FIREFOX: 'v2/media/almostdone/mac-firefox.png',
        MAC_OTHER: 'v2/media/almostdone/mac-other.png',
        MAC_SAFARI: 'v2/media/almostdone/mac-safari.png',

        WIN_CHROME: 'v2/media/almostdone/win-chrome.png',
        WIN_EDGE: 'v2/media/almostdone/win-edge.png',
        WIN_IE: 'v2/media/almostdone/win-ie.png',
        WIN_FIREFOX: 'v2/media/almostdone/win-firefox.png',
        WIN_OTHER: 'v2/media/almostdone/win-other.png',
    },
   
    OUTLOOK_GUIDE_OUTOOK_LOGO: 'v2/media/images/OG-Outlook.svg',
    OUTLOOK_GUIDE_CALENDAR: 'v2/media/images/OG-Outlook-Calendar.svg',
};


const whitelistOs = [
    'ios',
    'mac',
    'windows',
    'android'
];
  
const whitelistBrowser = [
    'safari',
    'chrome',
    'edge',
    'firefox',
    'ie'
];

function isObject(value) {
    return value !== null && typeof value === 'object';
}

export function withFullPath (obj) {
    const path = getOriginRoot();
    const newSources = {};
    for (let i in obj) {
        if (i === 'OUTLOOK_NEW_GUIDE' || i === 'OUTLOOK_GUIDE_INFO') {
            newSources[i] = obj[i];
            continue;
        }
        if (isObject(obj[i])) {
            newSources[i] = withFullPath(obj[i]);
        } else {
            newSources[i] = `${path}/${obj[i]}`;
        }
    }

    return newSources;
}

export function imageWithPath (src) {
    const path = getOriginRoot();
    return `${path}/${src}`;
}

const almostDoneImageMap = {
    IOS_OTHER: CommonImages.ALMOST_DONE.IOS_OTHER,
    IOS_CHROME: CommonImages.ALMOST_DONE.IOS_OTHER,
    IOS_SAFARI: CommonImages.ALMOST_DONE.IOS_SAFARI,
    IOS_FIREFOX: CommonImages.ALMOST_DONE.IOS_OTHER,

    MAC_CHROME: CommonImages.ALMOST_DONE.MAC_CHROME,
    MAC_FIREFOX: CommonImages.ALMOST_DONE.MAC_FIREFOX,
    MAC_SAFARI: CommonImages.ALMOST_DONE.MAC_SAFARI,
    MAC_OTHER: CommonImages.ALMOST_DONE.MAC_OTHER,

    WINDOWS_CHROME: CommonImages.ALMOST_DONE.WIN_CHROME,
    WINDOWS_EDGE: CommonImages.ALMOST_DONE.WIN_EDGE,
    WINDOWS_FIREFOX: CommonImages.ALMOST_DONE.WIN_FIREFOX,
    WINDOWS_IE: CommonImages.ALMOST_DONE.WIN_IE,
    WINDOWS_OTHER: CommonImages.ALMOST_DONE.WIN_OTHER,

    ANDROID_OTHER: CommonImages.ALMOST_DONE.IOS_OTHER,
    ANDROID_CHROME: CommonImages.ALMOST_DONE.IOS_OTHER,
    ANDROID_FIREFOX: CommonImages.ALMOST_DONE.IOS_OTHER,

    OTHER: CommonImages.ALMOST_DONE.WIN_OTHER,
};

function computeName (n, whitelist) {
    const found = n.match(new RegExp(`(${whitelist.join('|')})`, 'ig'));
    return found ? found.pop().toLowerCase() : '';
};

export function getAlmostDoneEntries (osSource, browser) {
    let os = osSource;
    if (os.toLowerCase() === 'mac os') {
        os = 'mac';
    } 
    const osName = computeName(os, whitelistOs) || 'windows';
    const browserName = computeName(browser, whitelistBrowser) || 'other';
    const imageKey = (osName + '_' + browserName).toUpperCase();
    const guideImage = imageWithPath(almostDoneImageMap[imageKey]);
    const dataPlatform = `${osName.toLowerCase()}${formalize(browserName)}`;

    return {
        guideImage,
        dataPlatform,
    };
};

function getAspectRatio (width, height) {
    if (width <= 0 || height <= 0) {
        return 'Invalid dimensions';
    }

    let w = width;
    let h = height;

    if (w === 0 || h === 0) {
        return "0:0"; // Or handle as appropriate for your use case
    }

    // Reduce by powers of 2
    while (w % 2 === 0 && h % 2 === 0) {
        w /= 2;
        h /= 2;
    }

    if (w === h) {
        w = 1;
        h = 1;
    }
    return `${w}:${h}`;
}
 
export function pixelToInt(value) {
    if (typeof value === 'string') {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue)) {
        return parsedValue;
      } else {
        return 0;
      }
    } else if (typeof value === 'number') {
      return Math.floor(value);
    }
    return 0;
}

export async function preloadSVGS ({ resolve, reject, url }) {
    const res =  await fetch('path/to/your/image.svg');
    const svgtext = await res.text();
    const widthMatch = svgtext.match(/<svg[^>]*width="([^"]*)"/);
    const heightMatch = svgtext.match(/<svg[^>]*height="([^"]*)"/);
    let width = 80;
    let height = 80;

    if (widthMatch && heightMatch) {
        width = widthMatch[1];
        height = heightMatch[1];
    }
    const aspectRatio = getAspectRatio(width, height);
    return {
        width,
        height,
        aspectRatio,
    };
}

// when new Image() failed on safari or firefox browser...
export function createVirtualImage (url) {
    return new Promise ((resolve) => {
        const img = document.createElement('img');
        img.style = 'display: none; position: absolute; visibility: hidden; top: 0; left: 0';
        img.src = url;
        img.onload = function () {
            document.body.removeChild(img);
            resolve({
                url: url,
                virtualURL: url,
                image: img,
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
        }
        document.body.appendChild(img);
    });
}

export function createImage (url) {
    return new Promise(async (resolve, reject) => {
        // console.log('createImage()   ', url);
        const fileExtension = url.split('.').pop().toLowerCase();
        if (fileExtension === 'svg') {
            const res = await preloadSVGS({
                resolve,
                reject,
                url,
            });
            resolve({
                ...res,
            });
            return;
        }
        const image = new Image();
        image.addEventListener('load', () => {
            const aratio = getAspectRatio(image.width, image.height);
            resolve({
                image,
                width: image.width,
                height: image.height,
                aspectRatio: aratio,
            });
        });

        image.addEventListener('error', async (error) => {
            let nUrl = url;
            // load the default when logo failed to load and png, svg and jpg is not part of the url
            if (!isImageURL(nUrl)) {
                const Images = withFullPath(CommonImages);
                nUrl = Images.ECAL_LOGO_ROUND;
            }
            console.log('createImage() image FAILED TO LOAD  error probably CORS-> ', nUrl);
            const img = await createVirtualImage(nUrl);
            // if virtual image is created it means the aspect ratio should default to 1:1 , with size : 80x80
            resolve({
                ...img,
                aspectRatio:  getAspectRatio(80, 80),
            });
        });
        image.src = url;
    });
}

/*
 * centralize computation of image props
 */
export function computeImagePropsSize (image, imageProps) {
    if (image.aspectRatio === '1:1') {
        if (imageProps.logoHeight >= 120) {
            imageProps.logoWidth = 120;
            imageProps.logoHeight = 120;
        }
    } else {
        if (imageProps.logoHeight >= 120) {
            const scale = 120 / imageProps.logoHeight;
            imageProps.logoHeight = 120;
            imageProps.logoWidth = imageProps.logoWidth.width * scale;
        }
    }
}

export function getImageProps (image) {
    const imageProps = {
        logoAspectRatio: image.aspectRatio,
        logoWidth: image.width,
        logoHeight: image.height,
    };
    
    computeImagePropsSize(image, imageProps);
    return imageProps;
}

export function isLogoAnImageURL (widget) {
    if (widget.logo && isImageURL(widget.logo)) {
        return true;
    }
    return false;
}

export function isImageURL (url) {
    if (url.includes('.png') || 
        url.includes('.jpg') ||
        url.includes('.jpeg') ||
        url.includes('.svg')
    ) {
        return true;
    }
    return false;
}


export default withFullPath(CommonImages);
